import { Columns } from '#types/grid';

export const columnDefinition: Columns = [
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.consignee',
    field: 'consignee',
    width: 100,
    sort: 'asc',
    sortOrder: 1,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.statusabbrev',
    field: 'statusabbrev',
    width: 60,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.name',
    field: 'name',
    width: 150,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.phone',
    field: 'phone',
    width: 90,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.contact',
    field: 'contact',
    width: 120,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.addr1',
    field: 'addr1',
    width: 140,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.addr2',
    field: 'addr2',
    width: 120,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.city',
    field: 'city',
    width: 100,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.state',
    field: 'state',
    width: 60,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.postalcode',
    field: 'postalcode',
    width: 60,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.billto',
    field: 'billto',
    width: 60,
    formatter: 'yn',
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.shipto',
    field: 'shipto',
    width: 60,
    formatter: 'yn',
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.consigneestatus',
    field: 'consigneestatus',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.ltlcarrier',
    field: 'ltlcarrier',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.tlcarrier',
    field: 'tlcarrier',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.spscarrier',
    field: 'spscarrier',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.billtoconsignee',
    field: 'billtoconsignee',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.shiptype',
    field: 'shiptype',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.shipterms',
    field: 'shipterms',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.shiptypeabbrev',
    field: 'shiptypeabbrev',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.shiptermsabbrev',
    field: 'shiptermsabbrev',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.lastuser',
    field: 'lastuser',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.lastupdate',
    field: 'lastupdate',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.consignee_rowid',
    field: 'consignee_rowid',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.countrycode',
    field: 'countrycode',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.fax',
    field: 'fax',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'consignee.consignee_lookup_dialog.grid.columns.email',
    field: 'email',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
];
